/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateGeneticsReportRequestDto
 */
export interface CreateGeneticsReportRequestDto {
    /**
     * Document name (max 255 characters, ASCII printable characters)
     * @type {string}
     * @memberof CreateGeneticsReportRequestDto
     */
    documentName: string;
    /**
     * File URL in storage
     * @type {string}
     * @memberof CreateGeneticsReportRequestDto
     */
    fileUrl?: string;
    /**
     * File type
     * @type {string}
     * @memberof CreateGeneticsReportRequestDto
     */
    fileType: CreateGeneticsReportRequestDtoFileTypeEnum;
    /**
     * File size in bytes (max 10MB = 10485760 bytes)
     * @type {number}
     * @memberof CreateGeneticsReportRequestDto
     */
    fileSize?: number;
}


/**
 * @export
 */
export const CreateGeneticsReportRequestDtoFileTypeEnum = {
    Pdf: 'pdf',
    Word: 'word',
    Image: 'image'
} as const;
export type CreateGeneticsReportRequestDtoFileTypeEnum = typeof CreateGeneticsReportRequestDtoFileTypeEnum[keyof typeof CreateGeneticsReportRequestDtoFileTypeEnum];


/**
 * Check if a given object implements the CreateGeneticsReportRequestDto interface.
 */
export function instanceOfCreateGeneticsReportRequestDto(value: object): value is CreateGeneticsReportRequestDto {
    if (!('documentName' in value) || value['documentName'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    return true;
}

export function CreateGeneticsReportRequestDtoFromJSON(json: any): CreateGeneticsReportRequestDto {
    return CreateGeneticsReportRequestDtoFromJSONTyped(json, false);
}

export function CreateGeneticsReportRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateGeneticsReportRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'documentName': json['documentName'],
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'fileType': json['fileType'],
        'fileSize': json['fileSize'] == null ? undefined : json['fileSize'],
    };
}

export function CreateGeneticsReportRequestDtoToJSON(json: any): CreateGeneticsReportRequestDto {
    return CreateGeneticsReportRequestDtoToJSONTyped(json, false);
}

export function CreateGeneticsReportRequestDtoToJSONTyped(value?: CreateGeneticsReportRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentName': value['documentName'],
        'fileUrl': value['fileUrl'],
        'fileType': value['fileType'],
        'fileSize': value['fileSize'],
    };
}

